import type { Locale } from '../i18n'

const intlLocale = (locale: Locale = 'en') => locale === 'zh' ? 'zh-CN' : 'en-US'

export const money = (value: number, digits = 1, locale: Locale = 'en') => {
  if (locale === 'zh' && Math.abs(value) >= 10000) {
    const scaled = Math.abs(value) >= 100000000 ? value / 100000000 : value / 10000
    const suffix = Math.abs(value) >= 100000000 ? '亿' : '万'
    return `${value < 0 ? '-' : ''}$${Math.abs(scaled).toFixed(digits).replace(/\.0+$/, '')}${suffix}`
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: Math.abs(value) >= 1000 ? 'compact' : 'standard',
    maximumFractionDigits: digits,
  }).format(value)
}

export const integer = (value: number, locale: Locale = 'en') => new Intl.NumberFormat(intlLocale(locale)).format(Math.round(value))
export const percent = (value: number, digits = 1) => `${(value * 100).toFixed(digits)}%`
export const signedPercent = (value: number) => `${value >= 0 ? '+' : ''}${(value * 100).toFixed(1)}%`
export const signedPoints = (value: number, locale: Locale = 'en') => `${value >= 0 ? '+' : ''}${(value * 100).toFixed(2)}${locale === 'zh' ? ' 个百分点' : ' pp'}`
export const monthLabel = (iso: string, locale: Locale = 'en') => new Intl.DateTimeFormat(intlLocale(locale), { month: locale === 'zh' ? 'numeric' : 'short', year: locale === 'zh' ? 'numeric' : '2-digit', timeZone: 'UTC' }).format(new Date(`${iso}T00:00:00Z`))
export const dateLabel = (iso: string, locale: Locale = 'en') => new Intl.DateTimeFormat(intlLocale(locale), { month: locale === 'zh' ? 'numeric' : 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${iso}T00:00:00Z`))
